import { axios } from '@/services/axios';

const copyPermissionsSet = async ({ id, currentCompany }) => {
    const res = await axios.post(`/permissionset/${id}/copy/${currentCompany}`);
    return res.data;
};

export default copyPermissionsSet;
